import { faWindowClose, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Input, InputGroup, InputGroupAddon } from "reactstrap";
import { defaultLanguage } from "../../helper/utility";
import { language } from "../../languageProvider/language/language";
import OutsideAlerter from "./OutsideClick";
import SearchResultsDigit from "./SearchResultsDigit";

const MAX_HEIGHT_RESULT_CONTAINER = 300;
const ITEM_HEIGTH = 50;

const SearchbarDigit = (props) => {
  const hideOrShowSearchResults = (display) => {
    if (display === "none") {
      props.setDisplaySearchResults(display);
    } else {
      props.setDisplaySearchResults(display);
    }
  };

  return (
    <>
      <OutsideAlerter
        searchText={props.searchText}
        hideOrShowSearchResults={hideOrShowSearchResults}
        className={
          props.mobileSearch
            ? "d-lg-none d-flex align-items-center w-100 position-relative custom-search-li mobile-search-li"
            : undefined
        }
      >
        <InputGroup style={{ position: "relative" }}>
          <Input
            onFocus={() => {
              if (props.searchText.length > 3) {
                props.setDisplaySearchResults("flex");
              }
            }}
            onBlur={() => {
              setTimeout(() => {
                props.setDisplaySearchResults("none");
              }, 200);
            }}
            type="text"
            name="search"
            id="search"
            placeholder={language[defaultLanguage].cerca_un_prodotto}
            value={props.searchText}
            onChange={props.handleSearchTextChange}
            onKeyUp={(e) => {
              props.handleSearch2(props.searchText);
            }}
          />
          {props.searchText.length > 0 && (
            <div
              style={{
                position: "absolute",
                right: "50px",
                zIndex: 3,
                top: "15%"
              }}
            >
              <FontAwesomeIcon
                onClick={() => props.resetSearchBar()}
                icon={faWindowClose}
              />
            </div>
          )}

          <InputGroupAddon addonType="append">
            <span className="input-group-text" style={{ height: "38px" }}>
              <FontAwesomeIcon icon={faSearch} />
            </span>
          </InputGroupAddon>
        </InputGroup>

        {props.searchText.length > 3 && (
          <div
            className="container-searchBar shadow"
            style={{
              width: props.mobileSearch ? "100%" : "60%",
              height: `${props.listFiltered.length * ITEM_HEIGTH + 45}px`,
              top: "50px",
              display: props.displaySearchResults,
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "white",
              position: "absolute",
              zIndex: "1",
              maxHeight: `${MAX_HEIGHT_RESULT_CONTAINER}px`
            }}
          >
            <p style={{ paddingLeft: "15px" }}>
              <strong>{`${props.listFiltered.length}`} </strong>
              {props.listFiltered.length > 1
                ? "Risultati Trovati"
                : "Risultato trovato"}
            </p>

            <div
              style={{
                width: "100%",
                overflowY:
                  props.listFiltered.length * ITEM_HEIGTH >
                  MAX_HEIGHT_RESULT_CONTAINER
                    ? "scroll"
                    : "hidden"
              }}
            >
              {props.listFiltered.map((el, index) => {
                return (
                  <SearchResultsDigit
                    itemHeigth={ITEM_HEIGTH}
                    key={index}
                    element={el}
                  />
                );
              })}
            </div>
          </div>
        )}
      </OutsideAlerter>
    </>
  );
};

export default SearchbarDigit;
